import { ChangeEvent } from "react";
import { TextField } from "@mui/material";
import { useSearchContext } from "../../../contexts/SearchContext";

const SearchText = () => {
  const { searchTerm, setSearchTerm } = useSearchContext();

  const value = searchTerm !== "*" ? searchTerm : "";

  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value !== "" ? event.target.value : "*";
    setSearchTerm(newValue);
  };

  return (
    <TextField
      value={value}
      onChange={onChange}
      placeholder="Digite o nome, código ou EAN da mercadoria"
      fullWidth
      variant="outlined"
      size="small"
      sx={{ background: "white" }}
    />
  );
};

export default SearchText;
